import {
  addMonths,
  format,
  isSameDay,
  subMonths,
  isWithinInterval,
  isSameMonth,
  isBefore,
} from 'date-fns';
import isFunction from 'lodash/isFunction';
import React, { useEffect, useState } from 'react';
import { makeMonth } from './utils';
import s from './DatePicker.module.css';

export const DatePicker = ({ onSelect, onCancel, onSave }) => {
  const [dateRef, setDateRef] = useState(new Date());
  const [start, setStart] = useState(null);
  const [end, setEnd] = useState(null);

  useEffect(() => {
    onSelect({ start, end });
  }, [start, end, onSelect]);

  const onDateClick = (date) => {
    if (!start && !end) return setStart(date);
    if (start && !end) {
      if (isSameDay(start, date)) return null;
      if (!isBefore(start, date)) return setStart(date);

      return setEnd(date);
    }

    setEnd(null);
    setStart(date);
    return null;
  };

  const saveHandler = () => isFunction(onSave) && onSave({ start, end });

  const cancelHandler = () => {
    setStart(null);
    setEnd(null);
    return isFunction(onCancel) && onCancel();
  };

  const prevMonth = () => setDateRef(subMonths(dateRef, 1));
  const nextMonth = () => setDateRef(addMonths(dateRef, 1));

  const generateCellClass = (date) => {
    if (isSameDay(date, start) || isSameDay(date, end)) return 'selected';
    if (isBefore(start, end) && isWithinInterval(date, { start, end })) {
      return 'inInterval';
    }
    if (isBefore(new Date(), date)) return 'future';
    if (isSameDay(date, new Date())) return 'today';
    if (!isSameMonth(date, dateRef)) return 'adjacent';
    return null;
  };

  return (
    <div className={s.wrapper}>
      <div className={s.header}>
        <button onClick={prevMonth}>
          <div className={s.arrowLeft} />
        </button>
        <div className={s.monthLabel}>{format(dateRef, 'MMMM Y')}</div>
        <button onClick={nextMonth}>
          <div className={s.arrowRight} />
        </button>
      </div>
      <div className={s.datepicker}>
        {makeMonth(dateRef).map((d) => {
          const isFuture = isBefore(new Date(), d);
          return (
            <button
              disabled={isFuture}
              key={d.toISOString()}
              className={s[generateCellClass(d)]}
              onClick={() => {
                onDateClick(d);
              }}
            >
              {d.getDate()}
            </button>
          );
        })}
      </div>
      <div className={s.footer}>
        <button className={s.cancel} onClick={cancelHandler}>
          Cancel
        </button>
        <button className={s.save} onClick={saveHandler}>
          Save
        </button>
      </div>
    </div>
  );
};
